import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const LABELS: Record<string, string> = {
  dashboard: 'Painel',
  mensal: 'Faturamento mensal',
  diario: 'Faturamento diário',
  afiliados: 'Afiliados',
  produtos: 'Produtos',
  importacoes: 'Importações',
  configuracoes: 'Configurações',
  usuarios: 'Usuários',
  perfis: 'Perfis e permissões',
  auditoria: 'Auditoria',
  'minha-conta': 'Minha conta',
};

export function Breadcrumbs() {
  const { pathname } = useLocation();
  const parts = pathname.split('/').filter(Boolean);
  return (
    <nav className="flex items-center gap-1 text-sm text-muted-foreground">
      {parts.map((p, i) => {
        const to = '/' + parts.slice(0, i + 1).join('/');
        const label = LABELS[p] ?? (p.length > 12 ? 'Detalhe' : p);
        const last = i === parts.length - 1;
        return (
          <span key={to} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="size-3.5" />}
            {last ? (
              <span className="font-medium text-foreground">{label}</span>
            ) : (
              <Link to={to} className="hover:text-foreground">
                {label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
